;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: "ServiceSearchSelect",
    props: ["currency", "service"],
    data: function data() {
        return {
            searchTerm: "",
            selectedResult: {},
            searchReseults: [],
            hasError: false,
            errorMessage: null,
            isLoading: false,
            currencyId: null
        };
    },

    computed: {
        service_id: function service_id() {
            return this.selectedResult.id;
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.currencyId = this.currency;
        if (this.service) {
            this.selectedResult = this.searchReseults.filter(function (item) {
                return item.id == _this.service;
            });
        }
    },

    methods: {
        setSelectedValue: function setSelectedValue(e) {
            this.service_id = this.selectedResult.id;
        },
        fetchData: function fetchData() {
            setTimeout(this.searchServie, 1000);
        },
        searchServie: function searchServie() {
            var _this2 = this;

            if (this.searchTerm === null) {
                this.hasError = true;
                this.errorMessage = "This field is required!";
            } else {
                this.isLoading = true;
                console.info("SEARCH VALUE", this.searchTerm);
                Vue.axios.get("/services/filtered?name=" + this.searchTerm + "&currency=" + this.currency).then(function (response) {
                    _this2.isLoading = false;
                    console.log(response.data);
                    _this2.searchReseults = response.data.services;
                }).catch(function (error) {
                    console.log(error.message);
                    _this2.hasError = "Not found";
                });
            }
        }
    }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[(_vm.account == null)?_c('div',{staticClass:"form-group d-flex align-items-center"},[_c('div',{staticClass:"form-group p-0 mb-0 w-full"},[_c('label',{attrs:{"for":"searchTerm"}},[_vm._v("Service")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-start w-full"},[_c('div',{staticClass:"w-full"},[_c('v-select',{attrs:{"options":_vm.searchReseults},on:{"change":_vm.fetchData},model:{value:(_vm.selectedResult),callback:function ($$v) {_vm.selectedResult=$$v},expression:"selectedResult"}}),_vm._v(" "),(_vm.hasError)?_c('span',{staticClass:"text-sm text-danger"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()],1),_vm._v(" "),(_vm.selectedResult)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.service_id),expression:"service_id"}],attrs:{"type":"hidden"},domProps:{"value":(_vm.service_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.service_id=$event.target.value}}}):_vm._e()])])]):_c('div',[_c('div',{staticClass:"form-group d-flex w-full align-items-start justify-content-between"},[_c('div',[_c('div',[_c('span',{staticStyle:{"color":"#475467","font-size":"0.875rem","font-weight":"400","line-height":"1.25"}},[_vm._v("Service\n                        Name:")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#1a202c","font-size":"0.875rem","font-weight":"500","line-height":"1.25"}},[_vm._v(_vm._s(_vm.selectedResult.name))])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-link text-danger p-0",attrs:{"type":"button"},on:{"click":_vm.clearSearch}},[_vm._v("\n                Remove\n            ")])])])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-244cbb30", __vue__options__)
  } else {
    hotAPI.reload("data-v-244cbb30", __vue__options__)
  }
})()}